let logoutHandler = null;

export const setLogoutHandler = (handler) => {
  logoutHandler = typeof handler === 'function' ? handler : null;
};

export const runLogoutHandler = async () => {
  if (!logoutHandler) return;

  try {
    await logoutHandler();
  } catch (error) {
    // Evita que el interceptor falle si logout arroja error
    // eslint-disable-next-line no-console
    console.error('logout handler error', error);
  }
};

export const clearLogoutHandler = () => {
  logoutHandler = null;
};